import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from "../../../../SpecialtyPersonalStyles.module.scss"
import metadata from './OtherExpoComponent.metadata.json5';

function OtherExpoComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('OtherExpoComponent');

    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        totHPofmotFie: {
            visible: _.get(modelVM,'outMotFie.value')
        },
        incidentalOfficeExposuresHeader: {
            visible: _.get(modelVM,'incOffUseFie.value')
        },
        pledesacttakplaontpreFie: {
            visible: _.get(modelVM,'incOffUseFie.value')
        },
        howmanhouperweeistactFie: {
            visible: _.get(modelVM,'incOffUseFie.value') || _.get(modelVM,'busonPreFie.value')
        },
        docliorsupevecomtopreFie: {
            visible: _.get(modelVM,'incOffUseFie.value') || _.get(modelVM,'busonPreFie.value')
        },
        ifyesexpFie: {
            visible:  _.get(modelVM,'docliorsupevecomtopreFie.value')
        },
        doyoucarliainsfortelsFie: {
            visible: _.get(modelVM,'incOffUseFie.value') || _.get(modelVM,'busonPreFie.value')
        },
        ifyespleproCarFie: {
            visible: _.get(modelVM,'doyoucarliainsfortelsFie.value')
        },
        ifyespleproPolFie: {
            visible: _.get(modelVM,'doyoucarliainsfortelsFie.value')
        },
        ifyespleproExpFie: {
            visible: _.get(modelVM,'doyoucarliainsfortelsFie.value')
        },
        areyouselFie: {
            visible: _.get(modelVM,'incOffUseFie.value') || _.get(modelVM,'busonPreFie.value')
        },
        namoffiryouworforFie: {
            visible: _.get(modelVM,'areyouselFie.value') === false
        },
        dothecarCGLInsfortbusFie: {
            visible: _.get(modelVM,'areyouselFie.value') === false
        },
        othcomFie: {
            visible: _.get(modelVM,'areyouselFie.value') === false
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

OtherExpoComponent.propTypes = wizardProps;
export default withRouter(OtherExpoComponent);
